import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { Link, useLocation } from "react-router-dom"

import { Drawer, LogoIcon } from "components"
import SidebarContent from "../SidebarContent"
import { useTranslation } from "react-i18next"

export const SidebarDrawer = ({ visible, toggleVisible, ...props }) => {
  const location = useLocation()
  const { t } = useTranslation()
  const onClose = () => {
    toggleVisible(false)
  }

  useEffect(() => {
    if (visible) {
      onClose()
    }
  }, [location])

  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      placement={"left"}
      className={"sidebar-drawer"}
      header={false}
    >
      <div className="navbar-brand-box mb-2">
        <Link to="/calendar" className="logo logo-light mb-2">
          <span className="logo-sm">
            <LogoIcon size="50" />
          </span>
          <div
            style={{
              lineHeight: "6px",
              fontSize: "12px",
              fontWeight: "500",
            }}
          >
            {t("administrator-portal")}
          </div>
        </Link>
      </div>
      <div className={"sidebar-drawer-content"}>
        <SidebarContent />
      </div>
    </Drawer>
  )
}

SidebarDrawer.propTypes = {
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func,
}
